"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SelectDropdown = _interopRequireDefault(require("./SelectDropdown"));

var _TokenList = _interopRequireDefault(require("./TokenList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/** TokenInput */
var _default = function _default(_ref) {
  var options = _ref.options,
      value = _ref.value,
      className = _ref.className,
      onSelect = _ref.onSelect,
      onAdd = _ref.onAdd,
      onRemove = _ref.onRemove;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'token-input input-like ' + (className || '')
  }, /*#__PURE__*/_react["default"].createElement(_TokenList["default"], {
    options: value,
    onSelect: onSelect,
    onRemove: onRemove
  }), /*#__PURE__*/_react["default"].createElement(_SelectDropdown["default"], {
    options: options,
    value: "",
    className: className,
    onChange: function onChange(value) {
      return onAdd(value);
    }
  }));
};

exports["default"] = _default;